import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';
import { inboxToggleCompactModeStatusSelector, inboxTogglePauseStatusSelector } from '../selectors/settings';
import type { UserSettings, AccountSettings } from '../reducers/settings';

export enum SettingsTypes {
  SET_SETTINGS = 'app/settings/SET_SETTINGS',

  TOGGLE_PAUSE_INBOX_REQUEST = 'app/settings/TOGGLE_PAUSE_INBOX_REQUEST',
  TOGGLE_PAUSE_INBOX_SUCCESS = 'app/settings/TOGGLE_PAUSE_INBOX_SUCCESS',
  TOGGLE_PAUSE_INBOX_FAILURE = 'app/settings/TOGGLE_PAUSE_INBOX_FAILURE',

  TOGGLE_INBOX_COMPACT_MODE_REQUEST = 'app/settings/FETCH_INBOX_TICKETS_REQUEST',
  TOGGLE_INBOX_COMPACT_MODE_SUCCESS = 'app/settings/TOGGLE_INBOX_COMPACT_MODE_SUCCESS',
  TOGGLE_INBOX_COMPACT_MODE_FAILURE = 'app/settings/TOGGLE_INBOX_COMPACT_MODE_FAILURE',
}

export const setSettings = (settings: { user: UserSettings, account: AccountSettings }) => ({
  type: SettingsTypes.SET_SETTINGS as const,
  payload: settings,
});

export const togglePauseInbox = (userId: string) => createThunklessAction({
  type: [
    SettingsTypes.TOGGLE_PAUSE_INBOX_REQUEST,
    SettingsTypes.TOGGLE_PAUSE_INBOX_SUCCESS,
    SettingsTypes.TOGGLE_PAUSE_INBOX_FAILURE,
  ] as const,
  promise: () => avo.ajax({ route: `/users/${userId}/toggle_pause_inbox`, method: 'PATCH' }),
  statusSelector: inboxTogglePauseStatusSelector,
});

export const toggleInboxCompactMode = (userId: string) => createThunklessAction({
  type: [
    SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_REQUEST,
    SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_SUCCESS,
    SettingsTypes.TOGGLE_INBOX_COMPACT_MODE_FAILURE,
  ] as const,
  promise: () => avo.ajax({ route: `/users/${userId}/toggle_compact_tickets`, method: 'PATCH' }),
  statusSelector: inboxToggleCompactModeStatusSelector,
});
